import { Content, Main } from "../../../components/Layout";
import { Col, Row } from "react-bootstrap";
import { InputColor, File } from "../../../components/Input";
import { useState, useEffect } from "react";
import Button from "../../../components/Button";
import api from "../../../services/api";
import useWrapper from "../../../hooks/useWrapper";
import { toast } from "react-toastify";
import useAppearance from "../../../hooks/useAppearance";

export default function WhiteLabel() {
  const { setbreadcrumb, config, token } = useWrapper();
  const { appearance, setappearance } = useAppearance();
  const [loading, setloading] = useState();

  const notify = async __message => {
    const NOTIFICATIONS_ENABLED = false;
    if (!NOTIFICATIONS_ENABLED) return false;
    if ("Notification" in window) {
      const _permission = await Notification.requestPermission();
      if (_permission === "granted") {
        new Notification("Atendimento Formou", {
          body: `${__message} ${Math.random()}`,
          icon: "/meta/apple-icon.png",
          tag: "last_attendance_message",
        });
      }
    }
    if ("seAppBadge" in navigator) {
      console.log("tem seAppBadge");
      await navigator.setAppBadge(10);
    } else {
      console.log("nao tem seAppBadge");
    }
  };
  useEffect(() => {
    setbreadcrumb([{ label: "Gerenciar Usuários" }]);
    notify("Bem-vindo!");
    // notify is a stable no-op stub (NOTIFICATIONS_ENABLED is false) recreated each render; only
    // run this effect once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setbreadcrumb]);

  const submitForm = async () => {
    setloading({
      ...loading,
      changes: true,
    });

    const uploadFile = async (__file, __key) => {
      if (!__file) return;
      try {
        let _body = new FormData();
        _body.append("file", __file);
        const _response = await api.post("files", _body, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
            [__key]: 1,
            pastapublica: 1,
          },
        });
        return _response;
      } catch (__error) {
        toast.error("Problemas ao subir o arquivo.");
        console.log("__error", __error);
      }
    };

    try {
      // Files Upload
      let _files = appearance?.files;
      for (const __file of Object.entries(appearance?.files_to_upload || {})) {
        const _key = __file[0];
        const _file_base64 = __file[1];
        const { data: _file } = await uploadFile(_file_base64, _key);
        _files[_key] = _file.id;
      }

      const _appearance_submit = {
        name: appearance?.name,
        description: appearance?.description,
        primary_color: appearance?.primary_color,
        primary_color_soft: appearance?.primary_color_soft,
        secondary_color: appearance?.secondary_color,
        secondary_color_soft: appearance?.secondary_color_soft,
        color_error: appearance?.color_error,
        color_error_soft: appearance?.color_error_soft,
        color_success: appearance?.color_success,
        color_success_soft: appearance?.color_success_soft,
        color_warning: appearance?.color_warning,
        color_warning_soft: appearance?.color_warning_soft,
        file_id: _files?.logo,
      };
      await api.post("white-label", _appearance_submit, config);
      window.location.reload();
      toast.success("Aparência Atualizada!");
    } catch (__err) {
      toast.error("Erro ao tentar atualizar aparência!");
      console.log("__err", __err);
    }
    setloading({
      ...loading,
      changes: false,
    });
  };

  return (
    <Main>
      <Content>
        <Row>
          <Col>
            <h2 className="mini-title">Gerenciar Aparência</h2>
            <p className="small-label font-italic mb-3">
              Aqui você pode customizar a algumas coisas relacionadas a aparência do sistema.
            </p>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <label>Logo</label>
            <File
              // disabled={!!isWaitingResponse}
              file_id={appearance?.files?.logo}
              file_to_upload={appearance?.files_to_upload?.logo}
              setFile={__file => {
                setappearance({
                  ...appearance,
                  files_to_upload: {
                    ...appearance?.files_to_upload,
                    logo: __file,
                  },
                });
              }}
              title="Logo"
            />
            {/* <File
              name="fileBoot"
              file={fileBoot[0]}
              fileLoaded={appearance.file}
              getRootProps={getRootProps}
              getInputProps={getInputProps}
              title="Foto Segurando RG"
            /> */}
          </Col>
          {/* <Col sm={3}>
            <label>Nome da Empresa</label>
            <InputText
              value={appearance?.name}
              onChange={__ev => {
                setappearance({
                  ...appearance,
                  name: __ev.target.value,
                });
              }}
            />
          </Col>
          <Col>
            <label>Slogan</label>
            <InputText
              value={appearance?.description}
              onChange={__ev => {
                setappearance({
                  ...appearance,
                  description: __ev.target.value,
                });
              }}
            />
          </Col> */}
        </Row>
        <Row className="mt-3">
          <Col sm={3}>
            <label>Cor Primária</label>
            <InputColor
              value={appearance?.primary_color}
              onChange={__ev => {
                setappearance({
                  ...appearance,
                  primary_color: __ev.target.value,
                });
              }}
            />
          </Col>
          <Col sm={3}>
            <label>Cor Primária Suave</label>
            <InputColor
              value={appearance?.primary_color_soft}
              onChange={__ev => {
                setappearance({
                  ...appearance,
                  primary_color_soft: __ev.target.value,
                });
              }}
            />
          </Col>
          <Col sm={3}>
            <label>Cor Secundária</label>
            <InputColor
              value={appearance?.secundary_color}
              onChange={__ev => {
                setappearance({
                  ...appearance,
                  secundary_color: __ev.target.value,
                });
              }}
            />
          </Col>
          <Col sm={3}>
            <label>Cor Secundária Suave</label>
            <InputColor
              value={appearance?.secundary_color_soft}
              onChange={__ev => {
                setappearance({
                  ...appearance,
                  secundary_color_soft: __ev.target.value,
                });
              }}
            />
          </Col>
        </Row>
        <Row className="mt-3">
          <Col sm={3}>
            <label>Cor Erro</label>
            <InputColor
              value={appearance?.color_error}
              onChange={__ev => {
                setappearance({
                  ...appearance,
                  color_error: __ev.target.value,
                });
              }}
            />
          </Col>
          <Col sm={3}>
            <label>Cor Erro Suave</label>
            <InputColor
              value={appearance?.color_error_soft}
              onChange={__ev => {
                setappearance({
                  ...appearance,
                  color_error_soft: __ev.target.value,
                });
              }}
            />
          </Col>
          <Col sm={3}>
            <label>Cor Advertência</label>
            <InputColor
              value={appearance?.color_warning}
              onChange={__ev => {
                setappearance({
                  ...appearance,
                  color_warning: __ev.target.value,
                });
              }}
            />
          </Col>
          <Col sm={3}>
            <label>Cor Advertência Suave</label>
            <InputColor
              value={appearance?.color_warning_soft}
              onChange={__ev => {
                setappearance({
                  ...appearance,
                  color_warning_soft: __ev.target.value,
                });
              }}
            />
          </Col>
        </Row>
        <Row className="mt-3">
          <Col sm={3}>
            <label>Cor Sucesso</label>
            <InputColor
              value={appearance?.color_success}
              onChange={__ev => {
                setappearance({
                  ...appearance,
                  color_success: __ev.target.value,
                });
              }}
            />
          </Col>
          <Col sm={3}>
            <label>Cor Sucesso Suave</label>
            <InputColor
              value={appearance?.color_success_soft}
              onChange={__ev => {
                setappearance({
                  ...appearance,
                  color_success_soft: __ev.target.value,
                });
              }}
            />
          </Col>
        </Row>
        <Row className="mt-3"></Row>
        <Row className="mt-3 justify-content-end">
          <Col className="d-flex justify-content-end">
            {/* <Button
              onClick={() => {
                notify("Clicando");
              }}
            >
              ...
            </Button> */}
            <Button onClick={submitForm} loading={loading?.changes}>
              Salvar
            </Button>
          </Col>
        </Row>
      </Content>
    </Main>
  );
}
